export const columns = [
    { id: "s.no", label: "S.No" },
    {
      id: "UG/PG programmes-Name",
      label: "UG/PG Programmes-Name",
      minWidth: 170,
      align: "center",
    },
    {
      id: "chairman/chairperson Name",
      label: "Chairman/Chairperson Name",
      minWidth: 170,
     
    },
  ];
  
  
  export const rows = [
      {
        "s.no": 1,
        "UG/PG programmes-Name": "CSE & IT - UG Programmes",
        "chairman/chairperson Name": "Dr. D. Rajya Lakshmi, Prof of CSE & DE-JNTUGV",
      },
      
    {
        "s.no": 2.,
        "UG/PG programmes-Name": "Artificial Intelligence(AI) and Emerging Technologies - UG Programmes",
        "chairman/chairperson Name": "Dr. G. Jaya Suma, Prof of IT & Registrar-JNTUGV",
        
      },
      {
        "s.no": 3.,
        "UG/PG programmes-Name": "M.Tech - All Specialisations and MCA - PG Programmes",
        "chairman/chairperson Name": "Dr. R. Rajeswara Rao, Prof of CSE & DAA-JNTUGV",
        
      },
      {
        "s.no": 4.,
        "UG/PG programmes-Name": "ECE - UG and PG Programmes",
        "chairman/chairperson Name": "Dr. K. Babulu, Prof of ECE & DA and D R&D-JNTUGV",
        
      },
      {
        "s.no": 5.,
        "UG/PG programmes-Name": "EEE - UG and PG Programmes *",
        "chairman/chairperson Name": "Dr. K. Sri Kumar, Prof of EEE & Principal,CEV",
        
      },
      {
        "s.no": 6.,
        "UG/PG programmes-Name": "Mechanical and Automobile Engineering - UG and PG Programmes",
        "chairman/chairperson Name": "Prof. VVS. Kesava Rao, Prof of Mechanical Engineering Andhra University Visakhapatnam",
        
      },
      {
        "s.no": 7.,
        "UG/PG programmes-Name": "Civil Engineering - UG and PG Programmes *",
        "chairman/chairperson Name": "Prof. K. Srinivasa Rao, Prof of Civil Engineering Andhra University Visakhapatnam",
        
      },
      {
        "s.no": 8.,
        "UG/PG programmes-Name": "Metallurgical Engineering - UG and PG Programmes *",
        "chairman/chairperson Name": "Prof. K. Srinivasa Rao, Prof of Metallurgical Engineering Andhra University Visakhapatnam",
        
      },
      {
        "s.no": 9.,
        "UG/PG programmes-Name": "SCience and Humanities - UG and PG Programmes *",
        "chairman/chairperson Name": "Prof. M. Sarath Chandra Babu, Prof of Chemistry Tribal University Vizianagaram",
        
      }
  ];
  